/**
 * Take a string and convert it to dash-case (className format type)
 * @param {*} str String to convert
 */
export const cn = (str = '') => str.trim().toLowerCase().replace(/\W/g, '-');
